import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { Control, Form, actions } from 'react-redux-form';
import ErrorMessage from '../../components/UI_Elements/ErrorMessage';
import debug from 'debug';
import Link from '../../../lib/components/link';

import classes from './Login.css';
import { loginAction, logoutAction } from '../../../store/actions/auth.actions';
import { RESET_AUTH_STATE } from '../../../store/actions/auth.types';
import { REQUEST_PASSWORD_VIEW } from '../../views/PasswordRequest/module/requestPassword';
import { REQUEST_USERNAME_VIEW } from '../../views/UsernameRequest/module/requestUsername';
import keyIcon from '../../../assets/images/key.png';
import { gciPageView } from '../../../lib/analytics';

const log = debug('huddle:app:views:login');

const pageTitle = 'Sign in';

export class Login extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    clickLogin: PropTypes.func.isRequired,
    authForm: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    resetForm: PropTypes.func.isRequired,
    error: PropTypes.shape({
      status: PropTypes.string,
      message: PropTypes.string,
      meta: PropTypes.shape({ fullUrl: PropTypes.string }),
    }),
  };

  static defaultProps = {
    login: () => {
      log('Error: defaultProps() not set for component Login');
    },
    clickLogin: () => {
      log('Error: defaultProps() not set for component Login');
    },
    resetForm: () => {
      log('Error: resetForm is undefined.');
    },
    authForm: {},
    isLoggedIn: false,
    error: null,
  };

  componentWillMount() {
    if (typeof window !== 'undefined' && this.props.isLoggedIn) {
      return window.location.href = '/myhuddle/Custom';
    }
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }

  render() {
    const { authForm, login, clickLogin, error } = this.props;

    return (
      <div className={classes.signInPageWrapper}>
        {error && <ErrorMessage error={error} />}
        <div className={classes.contentWrapper}>
          <div className={classes.signInBox}>
            <div className={classes.signInHeaderContent}>
              <div className={classes.signInHeader}>{pageTitle}</div>
              <img className={classes.keyIcon} src={keyIcon} alt="Sign In Icon" />
            </div>
            <div className={classes.formWrapper}>
              <Form model="auth" onSubmit={login} name="loginForm" method="post">
                <Control.text
                  model="auth.credentials.uname"
                  id="auth.credentials.uname"
                  placeholder="Username"
                  className={classes.loginText}
                  autoComplete="new-password"

                />
                <Control
                  type="password"
                  model="auth.credentials.password"
                  id="auth.credentials.password"
                  placeholder="Password"
                  className={classes.loginText}
                  autoComplete="new-password"
                />
                <Button
                  type="submit"
                  disabled={!authForm.$form.valid}
                  className={classes.loginButton}
                  id="auth.credentials.submit"
                >
                  Sign In
                </Button>
                <div className={classes.forgotWrapper}>
                  <Link
                    className={classes.forgotPassword}
                    to={{ type: REQUEST_PASSWORD_VIEW }}
                    label="Forgot your password?"
                  />&nbsp;&nbsp;
                  <Link
                    className={classes.forgotPassword}
                    to={{ type: REQUEST_USERNAME_VIEW }}
                    label="Forgot your username?"
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authForm: state.forms.auth,
  isLoggedIn: state.auth.loggedIn,
  error: state.auth.error,
});

const mapDispatchToProps = dispatch => ({
  clickLogin: () => dispatch(actions.submit('auth')),
  login: () => dispatch(loginAction),
  logout: () => dispatch(logoutAction),
  resetForm: () => dispatch({ type: RESET_AUTH_STATE }),
});

const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);

export default ConnectedLogin;



// WEBPACK FOOTER //
// ./src/app/views/Login/Login.js